import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'u-turn-right', 'UTurnRight', [["path",{"d":"M7 20v-11.5a4.5 4.5 0 0 1 9 0v8.5"}],["path",{"d":"M13 14l3 3l3 -3"}]]);